export default {
  data() {
    return {
      effortRateHourly: {
        1: 0.0619,
        2: 0.0516,
        3: 0.0413,
        4: 0.031,
        5: 0.031,
        6: 0.031,
        7: 0.031,
        8: 0.0206,
        9: 0.0206,
      },
      hourlyWageReference: 4.85,
      // The rate limit to which the CMG applies
      maxNetHelp: 8,
    };
  },
  computed: {
    /***
     *
     *  New CMG calculations
     *
     ***/

    /*****
     * This is the real total amount (net) paid to the assmat
     * including allowances (meal + transport + maintenance)
     ****/
    realMonthlyRateNet() {
      return this.maintenanceAllowanceMonthly +
          // this.transportAllowanceMonthly +
          this.mealAllowanceMonthly +
          this.net_mensualization_classic +
          this.net_monthy_overtime_increase;
    },
    realHourlyRateNet() {
      return this.realMonthlyRateNet / this.monthly_hours_f;
    },
    /*****
     * As we have a maximum of 8€ / hour (net) as rate paid for the cmg
     * we need to take the 8 euro if the amount paid to the assmat goes beyond
     ****/
    maxRealHourlyRate() {
      return Math.min(this.realHourlyRateNet, this.maxNetHelp);
    },
    /*****
     * Formula to calculate the new CMG 2025
     * ```
     * real hourly rate * monthly worked hours * ( 1 - ( net parent salary * hourly effort rate / gross hourly rate reference) )
     * ```
     * `real hourly rate` should have all the allowances, i.e. transport, meal and maintenance, plus
     * the hourly rate the employee perceives
     *****/
    newCMG() {
      return this.maxRealHourlyRate * this.monthly_hours_f *
          (1 - (this.averageMonthlySalaryParsed * this.effortRateHourly[this.children_i] / 100 / this.hourlyWageReference));
    },
    taxesCreditNewCMG() {
      return this.child_age_option.toString() === '6'
        ? 0
        : Math.min(
          Math.max(
            (
              this.grossTotal +
                      this.social_contributions_employer +
                      Math.min(this.maintenanceAllowanceMonthlyDetaxLimit, this.maintenanceAllowanceMonthly) -
                      this.socialContributionsCreditNewCMG -
                      this.newCMGEligibleAmount -
                      this.other_aid_f
            ) * 12 / 2,
            0
          ),
          this.taxLimit
        );
    },
    amountLeftPayable() {
      return Math.max(this.total_amount -
          this.socialContributionsCreditNewCMG -
          this.newCMGEligibleAmount -
          this.other_aid_f -
          (this.taxesCreditNewCMG / 12), 0);
    },
    amountLeftPayableBeforeTaxes() {
      return Math.max(this.total_amount -
          this.socialContributionsCreditNewCMG -
          this.newCMGEligibleAmount -
          this.other_aid_f, 0);
    },
    dailyCost() {
      return this.amountLeftPayable / this.monthly_worked_days_f;
    },
    hourlyCost() {
      return this.amountLeftPayable / this.monthly_hours_f;
    },
    newCMGEligibleAmount() {
      // Sometimes the cmg can be negative as the employer has a high monthly salary
      if (this.newCMGNotAvailable || this.newCMG < 0) {
        return 0;
      }

      return this.newCMG *
          // (this.situation === 'single' ? 1.3 : 1) *
          (this.handicap_toggle ? 1.3 : 1) *
          (this.cmgAidToggle === 'partial' ? 0.5 : 1);
    },
    youngestChildAgeTooOldNewCMG() {
      return this.youngestChildAge === 'greater-than-twelve' ||
          (this.youngestChildAge === 'six-or-more' && this.situation !== 'single');
    },
    newCMGNotAvailable() {
      return this.youngestChildAgeTooOldNewCMG || this.cmgAidToggle === 'no';
    },
    maxCMGHelpExceeded() {
      return this.realHourlyRateNet > this.maxNetHelp;
    },
  },
};
